<template>
    <div>
        <template v-if="true">
            <v-card class="primary">
                <v-layout row align-center class="pl-1 pt-1">
<!--Show Notes-->
                    <v-flex shrink class="pr-1">
                        <v-tooltip top>
                            <v-btn
                                    slot="activator"
                                    icon
                                    flat
                                    small
                                    :color="filterOptions.showNotes ? 'white' : 'amber'"
                                    class="pa-0 ma-0"
                                    @click="filterOptions.showNotes = !filterOptions.showNotes"
                            >
                                <v-icon>note</v-icon>
                            </v-btn>
                            <span>{{filterOptions.showNotes ? 'Hide Notes' : 'Show Notes'}}</span>
                        </v-tooltip>
                    </v-flex>
<!--Show Mails-->
                    <v-flex shrink class="pr-1">
                        <v-tooltip top>
                            <v-btn
                                    slot="activator"
                                    icon
                                    flat
                                    small
                                    :color="filterOptions.showMails ? 'white' : 'amber'"
                                    class="pa-0 ma-0"
                                    @click="filterOptions.showMails = !filterOptions.showMails"
                            >
                                <v-icon>mail</v-icon>
                            </v-btn>
                            <span>{{filterOptions.showMails ? 'Hide Mails' : 'Show Mails'}}</span>
                        </v-tooltip>
                    </v-flex>
<!--Show Documents-->
                    <v-flex shrink class="pr-1">
                        <v-tooltip top>
                            <v-btn
                                    slot="activator"
                                    icon
                                    flat
                                    small
                                    :color="filterOptions.showDocuments ? 'white' : 'amber'"
                                    class="pa-0 ma-0"
                                    @click="filterOptions.showDocuments = !filterOptions.showDocuments"
                            >
                                <v-icon>attachment</v-icon>
                            </v-btn>
                            <span>{{filterOptions.showDocuments ? 'Hide Documents' : 'Show Documents'}}</span>
                        </v-tooltip>
                    </v-flex>
<!--Show Events-->
                    <v-flex shrink class="pr-1">
                        <v-tooltip top>
                            <v-btn
                                    slot="activator"
                                    icon
                                    flat
                                    small
                                    :color="filterOptions.showEvents ? 'white' : 'amber'"
                                    class="pa-0 ma-0"
                                    @click="filterOptions.showEvents = !filterOptions.showEvents"
                            >
                                <v-icon>event</v-icon>
                            </v-btn>
                            <span>{{filterOptions.showEvents ? 'Hide Events' : 'Show Events'}}</span>
                        </v-tooltip>
                    </v-flex>


                    <v-flex xs12 class="pr-2 pl-1">
                        <v-layout row align-center>
                            <v-flex xs12>
                                <v-text-field
                                    prepend-inner-icon="search"
                                    label="Search"
                                    class="pa-0 ma-0"
                                    hide-details
                                    slot="activator"
                                    single-line
                                    v-model="filterOptions.filterStr"
                                    ref="refArea"
                                    color="white"
                                    dark
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex class="px-1" v-if="drawTimeOut != null">
                                <v-progress-circular
                                    :size="20"
                                    :width="3"
                                    color="white"
                                    indeterminate
                                />
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-spacer></v-spacer>

<!--User Filter-->
                    <v-flex shrink class="pr-1">
                        <v-tooltip top>
                            <v-btn
                                    slot="activator"
                                    icon
                                    flat
                                    small
                                    :color="!filterOptions.userOnly ? 'white' : 'amber'"
                                    class="pa-0 ma-0"
                                    @click="filterOptions.userOnly = !filterOptions.userOnly"
                            >
                                <v-icon>
                                    {{filterOptions.userOnly ? 'person' : 'people'}}
                                </v-icon>
                            </v-btn>
                            <span>{{filterOptions.userOnly ? 'Me Only' : 'All Users'}}</span>
                        </v-tooltip>
                    </v-flex>
<!--Order-->
                    <v-flex shrink class="pr-1">
                        <v-tooltip top>
                            <v-btn
                                    slot="activator"
                                    icon
                                    flat
                                    small
                                    color="white"
                                    class="pa-0 ma-0"
                                    @click="filterOptions.orderAscending = !filterOptions.orderAscending"
                            >
                                <v-icon>
                                    {{filterOptions.orderAscending ? 'arrow_upward' : 'arrow_downward'}}
                                </v-icon>
                            </v-btn>
                            <span>{{filterOptions.orderAscending ? 'Order Ascending' : 'Order Descending'}}</span>
                        </v-tooltip>
                    </v-flex>
<!--Task/Step Filter-->
                    <v-flex shrink class="pr-1">
                        <v-tooltip top>
                            <v-btn
                                    slot="activator"
                                    icon
                                    flat
                                    small
                                    :color="!filterOptions.stepOnly ? 'white' : 'amber'"
                                    class="pa-0 ma-0"
                                    @click="filterOptions.stepOnly = !filterOptions.stepOnly"
                            >
                                <v-icon>
                                    {{filterOptions.stepOnly ? 'view_list' : 'assignment_turned_in'}}
                                </v-icon>
                            </v-btn>
                            <span>{{filterOptions.stepOnly ? 'Step Attachments' : 'Task Attachments'}}</span>
                        </v-tooltip>
                    </v-flex>

                </v-layout>

                <div class="px-1 pt-1">


                </div>
            </v-card>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            filterOptions: Object,
            drawTimeOut: {
                required: true,
                validator: v => true
            }
        },
        data() {
            return {
                val: 'HELLO'
            }
        },
    }
</script>

<style scoped>

</style>
